import { toast } from 'react-hot-toast';
import { useMemo, useState } from 'react';
import { ColumnGroup } from 'react-table';
import styled from 'styled-components';
import dayjs from 'dayjs';

import { Button } from 'components/Button';
import { DeleteModal } from 'components/DeleteModal';
import { Headline } from 'components/Headline';

import { usersDataService } from 'services/users.service';

import { routes } from 'data/routes';
import { User } from 'types/api/users.type';

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const RestoreUserCell = ({ cell, setDeletedUsers }: any) => {
  const [isModalOpen, isModalOpenSet] = useState(false);

  const userId = cell.row.values.restore;

  const handleRestore = () => {
    isModalOpenSet(false);

    usersDataService
      .restoreUser(userId)
      .then(() => {
        toast.success(
          <Container>
            <Headline>User has been successfully restored</Headline>
            <Headline>
              <a href={routes.userView(userId)}>
                View user's profile
              </a>
            </Headline>
          </Container>,
          { duration: 5000 }
        );

        setDeletedUsers((prev: User[]) =>
          prev.filter((el) => el.restore !== userId)
        );
      })
      .catch(() => toast.error('Failed, please try again.'));
  };

  return (
    <>
      <Button
        motive="tableAction"
        onClick={() => isModalOpenSet(true)}
      >
        Restore a user
      </Button>

      {isModalOpen && (
        <DeleteModal
          hasLightOpacity
          customText="Are you sure you want to restore the selected user?"
          onClose={() => isModalOpenSet(false)}
          onDelete={handleRestore}
        />
      )}
    </>
  );
};

const createColumns = (setDeletedUsers: Function) =>
  useMemo(
    (): ColumnGroup[] => [
      {
        Header: 'Users',
        columns: [
          {
            Header: 'Name',
            accessor: 'name',
          },
          {
            Header: 'Last Name',
            accessor: 'surname',
          },
          {
            Header: 'Email',
            accessor: 'email',
          },
          {
            Header: 'Time and date of deletion',
            accessor: 'timestamp',
            Cell: ({ value }) => (
              <>{dayjs(value).format('DD/MM/YYYY, h:mm A')}</>
            ),
          },
          {
            Header: 'Restore',
            accessor: 'restore',
            disableSortBy: true,
            Cell: (cell) => (
              <RestoreUserCell
                cell={cell}
                setDeletedUsers={setDeletedUsers}
              />
            ),
          },
        ],
      },
    ],
    [setDeletedUsers]
  );

export { createColumns };
